'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.styles = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _EDSContext = require('../../EDSContext/EDSContext');

var _DrawerWrapper = require('../../DrawerWrapper/DrawerWrapper');

var _DrawerWrapper2 = _interopRequireDefault(_DrawerWrapper);

var _Typography = require('../../Typography/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _styles = require('../../styles');

var _styles2 = _interopRequireDefault(_styles);

var _tokens = require('../../styles/tokens');

var _isNil = require('lodash/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = exports.styles = function styles(theme) {
    return {
        root: {
            display: 'inline-block'
        },
        popperText: {
            marginBottom: _tokens.spacing40
        },
        content: {
            paddingLeft: _tokens.spacing40,
            paddingRight: _tokens.spacing40
        },
        textContent: {
            paddingTop: _tokens.spacing40
        }
    };
};

/**
 * `MobilePopper` to be rendered only on mobile platforms.
 */

var MobilePopper = function (_React$Component) {
    _inherits(MobilePopper, _React$Component);

    function MobilePopper() {
        _classCallCheck(this, MobilePopper);

        return _possibleConstructorReturn(this, (MobilePopper.__proto__ || Object.getPrototypeOf(MobilePopper)).apply(this, arguments));
    }

    _createClass(MobilePopper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.onClose) {
                console.log('onClose is required for the mobile variant of Popper');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                classes = _props.classes,
                id = _props.id,
                className = _props.className,
                children = _props.children,
                TitleTypographyProps = _props.TitleTypographyProps,
                TextTypographyProps = _props.TextTypographyProps,
                PaperProps = _props.PaperProps,
                open = _props.open,
                DrawerProps = _props.DrawerProps,
                onClose = _props.onClose,
                text = _props.text,
                title = _props.title;
            var popperText = classes.popperText,
                textContent = classes.textContent;


            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    _DrawerWrapper2.default,
                    {
                        title: title,
                        id: id,
                        PaperProps: PaperProps,
                        DrawerProps: DrawerProps,
                        open: open,
                        handleClose: onClose,
                        TitleTypographyProps: TitleTypographyProps
                    },
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)(classes.content, _defineProperty({}, textContent, !(0, _isNil2.default)(title))) },
                        text && _react2.default.createElement(
                            _Typography2.default,
                            Object.assign({
                                gutterBottom: true,
                                className: (0, _classnames2.default)(_defineProperty({}, popperText, children !== undefined))
                            }, TextTypographyProps),
                            text
                        ),
                        children
                    )
                )
            );
        }
    }]);

    return MobilePopper;
}(_react2.default.Component);

MobilePopper.propTypes = {

    /**
     * @ignore
     *
     * Classes used to extend original style object.
     */
    classes: _propTypes2.default.object,

    /**
     * A CSS class that will be applied to the parent `div`.
     */
    className: _propTypes2.default.string,

    /**
     * The contents of the popper.
     */
    children: _propTypes2.default.node,

    /**
     * Props provided to the text `Typography` component
     */
    TextTypographyProps: _propTypes2.default.object,

    /**
     * Props provided to the title `Typography` component
     */
    TitleTypographyProps: _propTypes2.default.object,

    /**
     * The id is applied to the top level of the mobile popper
     */
    id: _propTypes2.default.string,

    /**
     * Props applied to the `Paper` component
    */
    PaperProps: _propTypes2.default.object,

    /**
     * Set to `true` to make the the popper visible.
     */
    open: _propTypes2.default.bool.isRequired,

    /**
     * The text of the popper
     */
    text: _propTypes2.default.string,

    /**
     * Title of the poppper
     */
    title: _propTypes2.default.string,

    /**
     * Fires when the Popper closes.
     */
    onClose: _propTypes2.default.func,

    /**
     * Props applied to the `Drawer` element.
     */
    DrawerProps: _propTypes2.default.object

};

MobilePopper.defaultProps = {
    initialOpenOverride: false
};

exports.default = (0, _EDSContext.withEDSContext)((0, _styles2.default)(styles)(MobilePopper));